import { RECEIVE_CONFIG } from '../ActionsConst';

const initialState = {
  isUserAndAccountConfigLoaded: false,
  permissions: [],
  editableAccountSettings: [],
  contacts: { toPopulateProductPage: { type: 'accountManager' } },
  productSizesAvailable: {},
  internalUser: false,
  availableStores: [],
  selectedStoreCode: '',
  selectedLocale: 'en-gb',
};

const getLocale = (storeCode) => {
  const locales = {
    us: 'en-us',
    ca: 'en-us',
    uk: 'en-gb',
    au: 'en-gb',
    eu: 'en-gb',
  };
  return locales[storeCode] || 'en-gb';
};

const config = (state = initialState, action) => {
  switch (action.type) {
    case RECEIVE_CONFIG: {
      if (action.config.selectedStoreCode) {
        return {
          ...state,
          ...action.config,
          isUserAndAccountConfigLoaded: true,
          selectedLocale: getLocale(action.config.selectedStoreCode),
        };
      }
      return { ...state, isUserAndAccountConfigLoaded: true, ...action.config };
    }
    default:
      return state;
  }
};

export default config;
